/* eslint-disable react/display-name */
import {
  Box,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from "@material-ui/core";
import { forwardRef } from "react";
import { IoIosInformationCircle } from "react-icons/io";
import { TableVirtuoso } from "react-virtuoso";

import { BodyCell, HeadCell, StyledTableHead, TableContent } from "../../style";

const TableComponents = {
  Scroller: forwardRef((props, ref) => (
    <TableContent component={Paper} {...props} ref={ref} />
  )),
  Table: props => (
    <Table stickyHeader {...props} style={{ borderCollapse: "separate" }} />
  ),
  TableHead: TableHead,
  TableRow: TableRow,
  TableBody: forwardRef((props, ref) => <TableBody {...props} ref={ref} />)
};

export const SummaryStockTable = ({ stockData, loading }) => {
  const TableHeader = () => (
    <>
      <StyledTableHead>
        <HeadCell width={"10rem"}>SKU</HeadCell>
        <HeadCell width={"25rem"}>Nome</HeadCell>
        <HeadCell width={"15rem"} align="center">
          ID Produto base
        </HeadCell>
        <HeadCell width={"10rem"} align="center">
          Margem
        </HeadCell>
        <HeadCell width={"15rem"} align="center">
          Estoque
        </HeadCell>
        <HeadCell width={"12rem"} align="center">
          Tipo
        </HeadCell>
      </StyledTableHead>
      {loading && (
        <TableRow>
          <td colSpan={6} style={{ padding: 0 }}>
            <LinearProgress />
          </td>
        </TableRow>
      )}
    </>
  );

  return (
    <TableVirtuoso
      style={{ height: 500 }}
      data={stockData}
      components={{
        ...TableComponents,
        TableHead: TableHeader
      }}
      fixedHeaderContent={() => <TableHeader />}
      itemContent={(_, stock) => (
        <>
          <BodyCell width={"10rem"}>{stock.sku}</BodyCell>
          <BodyCell width={"25rem"}>{stock.name}</BodyCell>
          <BodyCell width={"15rem"} align="center">
            {stock.product_base_id}
          </BodyCell>
          <BodyCell width={"10rem"} align="center">
            {stock.margin}
          </BodyCell>

          <BodyCell width={"15rem"} align="center">
            <Box
              display="flex"
              style={{ gap: "0.5rem" }}
              justifyContent="center"
              alignItems="flex-end"
            >
              {stock.quantity_available}{" "}
              <Tooltip
                title={
                  <Typography style={{ whiteSpace: "pre-line" }}>
                    {stock.calculation_explanation.replace(/`/g, "")}
                  </Typography>
                }
                placement="top"
                arrow
              >
                <div style={{ height: "18px" }}>
                  <IoIosInformationCircle size={20} color="#b0b0b0" />
                </div>
              </Tooltip>
            </Box>
          </BodyCell>

          <BodyCell
            width={"12rem"}
            align="center"
            style={{ textTransform: "capitalize" }}
          >
            {stock.portion_type}
          </BodyCell>
        </>
      )}
    />
  );
};
